import { Helmet } from 'react-helmet'
import { useTranslate } from '../TranslationsContext'

export function MetaTags() {
  const translate = useTranslate()

  return (
    <Helmet>
      <title>{translate('Metatag.title')}</title>
      <meta name="description" content={translate('Metatag.description')} />
    </Helmet>
  )
}
